import { createCtx } from './contextFactory';

const [ctx, Provider] = createCtx({
    user: {},
    profile: {},
    sale: {}
});

export const MembershipJoinContext = ctx;

export const MembershipJoinProvider = Provider;
